<template>
  <div>
    <b-row>
      <b-col cols="12" lg="6" md="6" xl="6" sm="12" xs="12" offset-md="6" offset-lg="6" offset-xl="6" offset-sm="0" offset-xs="0">
        <div class="welcome">
          <img class="brand" src="@/assets/logo.png" />
          <h4 class="sub-title">{{ msgsub }}</h4>
          <h1 class="title">{{ msg }}<span>{{ companyname }}</span></h1>
          <p class="desc">Web Application Modules to show all reports from E-T-A ERP Application for Customs.</p>
          <div class="eta-nav">
            <a href="https://customs.tabieta.net/" class="btn btn-success"><b-icon icon="award"></b-icon>&nbsp;
            Go to Customs Web Reporting</a>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data () {
    return {
      companyname: 'E-T-A Customs Modules',
      msg: '',
      msgsub: 'Welcome Back!'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Welcome.vue